import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { ContainerType } from "../..";

@Injectable()
export class ContainerTypeService extends BaseDataService<ContainerType> {
  constructor(http: HttpService) {
    super(http, "containertype");
  }

  createInstance(options: any): ContainerType {
    return new ContainerType(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
